__turbopack_context__.v({
  "banner": "ofpvLa_banner",
  "closeButton": "ofpvLa_closeButton",
  "container": "ofpvLa_container",
  "content": "ofpvLa_content",
  "copy": "ofpvLa_copy",
  "icon": "ofpvLa_icon",
  "label": "ofpvLa_label",
  "link": "ofpvLa_link",
  "message": "ofpvLa_message",
  "mobileLink": "ofpvLa_mobileLink",
  "textContainer": "ofpvLa_textContainer",
});
